import api from './index';

export default {
  index(params) {
    return api({
      method: 'get',
      url: `api/notifications`,
      params,
    });
  },
  getById(id, params) {
    return api({
      method: 'get',
      url: `api/notifications/${id}`,
      params,
    });
  },
  confirm(id, data) {
    return api({
      method: 'post',
      url: `api/notifications/${id}/confirm`,
      data,
    });
  },
  createAccounts(id, data) {
    return api({
      method: 'post',
      url: `api/notifications/${id}/accounts`,
      data,
    });
  },
};
